const calculators = [
  // Customer Metrics
  {
    id: 1,
    name: 'CPC Calculator',
    description: 'Calculate your Cost Per Click for advertising campaigns',
    path: '/calculators/cost-per-click'
  },
  {
    id: 2,
    name: 'CPA Calculator',
    description: 'Measure your Cost Per Acquisition',
    path: '/calculators/cost-per-acquisition'
  },
  {
    id: 3,
    name: 'ROI Calculator',
    description: 'Calculate Return on Investment for your marketing efforts',
    path: '/calculators/roi'
  },
  {
    id: 4,
    name: 'CAC Calculator',
    description: 'Measure Customer Acquisition Cost',
    path: '/calculators/customer-acquisition-cost'
  },
  {
    id: 5,
    name: 'CLV Calculator',
    description: 'Calculate Customer Lifetime Value',
    path: '/calculators/customer-lifetime-value'
  },

  // Web Analytics
  {
    id: 10,
    name: 'Conversion Rate Calculator',
    description: 'Calculate your website conversion rate',
    path: '/calculators/conversion-rate'
  },
  {
    id: 11,
    name: 'Bounce Rate Calculator',
    description: 'Measure your website bounce rate',
    path: '/calculators/bounce-rate'
  },
  {
    id: 12,
    name: 'Landing Page Conversion Calculator',
    description: 'Calculate landing page conversion rates',
    path: '/calculators/landing-page-conversion-rate'
  },

  // Advertising Metrics
  {
    id: 20,
    name: 'CPM Calculator',
    description: 'Calculate Cost Per Mille (thousand impressions)',
    path: '/calculators/cost-per-mille'
  },
  {
    id: 21,
    name: 'ROAS Calculator',
    description: 'Measure Return on Ad Spend',
    path: '/calculators/return-on-ad-spend'
  },
  {
    id: 22,
    name: 'eCPM Calculator',
    description: 'Calculate effective Cost Per Mille',
    path: '/calculators/effective-cost-per-mille'
  },

  // Email Marketing
  {
    id: 31,
    name: 'Email Open Rate Calculator',
    description: 'Calculate the percentage of recipients who open your emails',
    path: '/calculators/email-open-rate'
  },
  {
    id: 32,
    name: 'Email Click-Through Rate Calculator',
    description: 'Measure the click-through rate of your email campaigns',
    path: '/calculators/email-click-through-rate'
  },
  {
    id: 33,
    name: 'Email Unsubscribe Rate Calculator',
    description: 'Calculate the rate at which recipients unsubscribe',
    path: '/calculators/email-unsubscribe-rate'
  },
  {
    id: 34,
    name: 'Email Campaign ROI Calculator',
    description: 'Measure the return on investment for email campaigns',
    path: '/calculators/email-campaign-roi'
  },
  {
    id: 35,
    name: 'Newsletter Churn Rate Calculator',
    description: 'Calculate newsletter subscriber churn rate',
    path: '/calculators/newsletter-churn-rate'
  },

  // Social Media
  {
    id: 40,
    name: 'Social Media ROI Calculator',
    description: 'Calculate return on investment for social media campaigns',
    path: '/calculators/social-media-roi'
  },
  {
    id: 41,
    name: 'Social Media Engagement Rate Calculator',
    description: 'Measure social media engagement rates',
    path: '/calculators/social-media-engagement-rate'
  },

  // Content Marketing
  {
    id: 50,
    name: 'Content Marketing ROI Calculator',
    description: 'Calculate ROI for content marketing efforts',
    path: '/calculators/content-marketing-roi'
  },
  {
    id: 51,
    name: 'Blog Post Read Rate Calculator',
    description: 'Measure blog post engagement rates',
    path: '/calculators/blog-post-read-rate'
  }
];

export default calculators;